
import notification, { Snack } from '@/store/notification';
import Vue from 'vue';

export default Vue.extend({
  name: 'Snackbar',

  data() {
    return {
      show: false,
      top: true,
      message: undefined as string | undefined,
      color: undefined as string | undefined,
      timeout: undefined as number | undefined,
    };
  },

  computed: {
    currentSnack(): Snack | undefined {
      return notification.state.snack;
    },
  },

  watch: {
    currentSnack(snack: Snack | undefined) {
      if (snack) {
        this.message = snack.message;
        this.timeout = snack.sticky ? -1 : 3000;
        if (snack.level === 'warn') {
          this.color = 'orange';
        } else if (snack.level === 'error') {
          this.color = 'red';
        } else {
          this.color = undefined;
        }
      }
      this.show = !!snack;
    },
  },

});
